/**
 * The Convergence Instruments mark, in the variant that suits the appearance.
 *
 * The stock mark's swoosh is #231f20 and all but vanishes against the dark
 * theme's surfaces, and the corporate site publishes no light variant. The
 * dark-mode file is that mark with only its near-neutral dark pixels lifted --
 * the teal monogram and the light-grey arc are byte-identical, so this is the
 * same logo rather than a redrawn one.
 *
 * Both images are rendered and CSS picks between them, rather than choosing in
 * JS. The theme can come from an explicit data-theme attribute OR from
 * prefers-color-scheme, and CSS already resolves that precedence for every
 * other token; selecting in JS would duplicate that logic and swap the src
 * after mount, which is a visible flip on load.
 *
 * The accessible name lives on the wrapper, with both images hidden from
 * assistive tech, so the logo is announced once rather than twice.
 *
 * `variant` pins the choice for surfaces that do not follow the theme. The
 * navbar is navy in BOTH appearances, so the light mark's near-black swoosh is
 * unreadable there even in light mode -- the variant has to follow the surface
 * it sits on, not the theme. Left unset, it follows the theme, which is right
 * for anything on --surface.
 */
export default function BrandMark({ className = '', alt = 'Convergence Instruments', variant }) {
  return (
    <span
      className={`brand-mark ${className}`.trim()}
      data-variant={variant}
      role="img"
      aria-label={alt}
    >
      <img className="brand-mark-light" src="/brand/ci-icon-192.png" alt="" aria-hidden="true" />
      <img className="brand-mark-dark" src="/brand/ci-icon-dark-192.png" alt="" aria-hidden="true" />
    </span>
  )
}
